import React, { memo } from 'react';
import { css, useTheme } from '@emotion/react';

type ButtonThemeType =
  | undefined
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'primaryUnlimited'
  | 'transparent'
  | 'in-visible';

export type ButtonProps = {
  children: React.ReactNode;
  kind?: ButtonThemeType;
  //so we can pass through any other native button attribute
  [wildcard: string]: any;
};

/**
 * A simple wrapper for 'button' incorporating theme styling
 */
export const Button = memo((props: ButtonProps) => {
  const theme = useTheme();
  const { children, kind = 'primary', ...allOtherProps } = props;
  let button;
  switch (kind) {
    case 'primaryUnlimited':
      button = css`
        && {
          ${theme.mixins.btnPrimaryUnlimited}
        }
      `;
      break;
    case 'secondary':
      button = css`
        && {
          ${theme.mixins.btnSecondary}
        }
      `;
      break;
    case 'tertiary':
      button = css`
        && {
          ${theme.mixins.btnTertiary}
        }
      `;
      break;
    case 'transparent':
      button = css`
        && {
          ${theme.mixins.btnTransparent}
        }
      `;
      break;
    case 'in-visible':
      button = css`
        && {
          ${theme.mixins.btnInvisible}
        }
      `;
      break;
    case 'primary':
    default:
      button = css`
        && {
          ${theme?.mixins?.btnPrimary}
        }
      `;
      break;
  }

  return (
    <button css={button} {...allOtherProps}>
      {children}
    </button>
  );
});
